var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import { Badge, CodeInput, Link, LoadingSpinner, Text, Toast } from '@paypalcorp/pp-react';
import { getProp } from '../common/utils';
import { PUBLIC_CREDENTIAL } from '../common/views';
import ProfileBar from './ProfileBar';
export default ({ authEventHandler, challengeId, csrf, forgetUser, isAutoOtp, isCookiedUser, isAaeUser, localizedContent, logger, maskedPhoneNumber = '', sendOtpChallenge, setShowTryAnotherWay, sessionID, setView, updateAfterOtpSent, publicCredential, setPublicCredential, verifyOtp, }) => {
    const [otp, setOtp] = useState('');
    const [otpFieldError, setOtpFieldError] = useState('');
    const [showSpinner, setShowSpinner] = useState(false);
    const [showResendSpinner, setShowResendSpinner] = useState(false);
    const [showOtpResent, setShowOtpResent] = useState(false);
    const [showOtpResentFailed, setShowOtpResentFailed] = useState(false);
    const [citStartTime, setCitStartTime] = useState('');
    const ref = useRef([]);
    useEffect(() => {
        var _a;
        setCitStartTime(Date.now());
        (_a = ref === null || ref === void 0 ? void 0 : ref.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
        logger.track('otp_rendered');
        logger.flush({ csrf, sessionID });
    }, []);
    const handleResendOtpClicked = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        logger.track('resend_otp_clicked');
        setShowResendSpinner(true);
        authEventHandler({ event: 'resendOtpLinkClicked' });
        logger.track('resend_otp_started');
        const response = yield sendOtpChallenge({ selectedChallengeId: challengeId });
        const nonce = getProp(response, 'data.otp.sendOtpNotification.nonce');
        if (nonce) {
            setOtp('');
            updateAfterOtpSent({ response });
            setShowOtpResent(true);
            setTimeout(() => {
                setShowOtpResent(false);
            }, 5000);
        }
        else {
            setShowOtpResentFailed(true);
            setTimeout(() => {
                setShowOtpResentFailed(false);
            }, 5000);
        }
        logger.track('resend_otp_' + (nonce ? 'succeeded' : 'failed'));
        setShowResendSpinner(false);
    });
    const handleChangeOtp = (pin) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // Prevent proceeding in case spinner is shown (implying a network request is underway)
        if (showSpinner) {
            return;
        }
        if (otpFieldError) {
            setOtpFieldError('');
        }
        setOtp(pin);
        if (pin.match(/\s/)) {
            return;
        }
        if (!pin.match(/\d{6}/)) {
            setOtpFieldError(localizedContent('otpCodeError'));
            return;
        }
        const startTime = Date.now();
        authEventHandler({ event: 'beginLogin', data: { loginMethod: 'otp' } });
        setShowSpinner(true);
        logger.track('otp_submitted');
        logger.track(`cpl_cit_otp_code|${JSON.stringify({
            start: citStartTime,
            tt: Date.now() - citStartTime,
            login_experience: 'OTP Login submit',
        })}`);
        logger.flush({ csrf, sessionID });
        const response = yield verifyOtp({ securityCode: pin.trim() });
        // XO Lite apps do not have the ngRL JS SDK loaded,
        // hence a captcha response can go unhandled
        // the following is a poor way to handle it so that XO can fallback
        const extensions = getProp(response, 'extensions', null);
        if (!extensions) {
            authEventHandler({
                event: response === 'invalid_ctxId' ? 'invalidCtxId' : 'unknownResponse',
                data: {
                    response,
                },
            });
        }
        const accessToken = getProp(response, 'data.otp.verifyOtp.accessToken');
        const status = getProp(response, 'data.otp.verifyOtp.status');
        logger.track('otp_' + (accessToken && status !== 'failed' ? 'succeeded' : 'failed'));
        if (accessToken) {
            // In case of a stepup, the status will be "failed"
            logger.track(status === 'failed' ? 'login_contingency' : 'user_logged_in');
            logger.track(`cpl_otp_login|${JSON.stringify({
                start: startTime,
                tt: Date.now() - startTime,
                login_experience: 'OTP submit',
            })}`);
            authEventHandler({
                event: status === 'failed' || !accessToken ? 'loginFailed' : 'loggedIn',
                data: { accessToken, loginMethod: 'otp' },
            });
        }
        else {
            logger.track('invalid_otp');
            logger.track(`cpl_otp_login|${JSON.stringify({
                start: startTime,
                tt: Date.now() - startTime,
                login_experience: 'OTP submit error',
            })}`);
            setOtp('');
            setOtpFieldError(localizedContent('otpCodeError'));
            (_a = ref === null || ref === void 0 ? void 0 : ref.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
            setShowSpinner(false);
            authEventHandler({
                event: 'loginFailed',
                data: { loginMethod: 'otp' },
            });
        }
        logger.flush({ csrf, sessionID });
    });
    return (React.createElement(React.Fragment, null,
        showSpinner && (React.createElement("div", { className: "overlay-spinner" },
            React.createElement(LoadingSpinner, { screenReaderText: localizedContent('loading'), size: "xl" }))),
        isAutoOtp && isCookiedUser && (React.createElement(ProfileBar, { publicCredential: publicCredential, handleClickChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                e.preventDefault();
                logger.track('change_user_clicked');
                setPublicCredential('');
                forgetUser({});
                setView(PUBLIC_CREDENTIAL);
            }), labelForChange: localizedContent('notYou') })),
        React.createElement("div", { className: !isCookiedUser ? 'slide-in' : '', style: { margin: '0 auto', marginBottom: '35px' }, id: "otpCodeContainer", "data-testid": "otp-code-container" },
            showOtpResent && (React.createElement(Toast, { id: "successToast", "data-testid": "success-toast", message: localizedContent('newCodeSent'), duration: 5000, isSuccess: true })),
            showOtpResentFailed && (React.createElement(Toast, { id: "failureToast", "data-testid": "failure-toast", message: localizedContent('genericErrorHeading'), duration: 5000 })),
            React.createElement("div", null,
                React.createElement(Text, { size: "xl2", className: "heading", id: "otpHeading", "data-testid": "otp-heading" }, localizedContent(isAutoOtp && isAaeUser ? 'accountFound' : 'loginWithOtp')),
                React.createElement("p", { className: "subHeading", id: "otpSubHeading", "data-testid": "otp-sub-heading" },
                    localizedContent('codeSentToMaskedPhoneNumber', {
                        maskedPhoneNumber: maskedPhoneNumber.replace(/X/g, '•'),
                    }),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    showResendSpinner ? (React.createElement(Badge, { type: "neutral", id: "otpResendBadge", "data-testid": "otp-resend-badge" }, localizedContent('resending'))) : (React.createElement(Link, { href: "#", className: "secondaryLink", id: "linkGetNewCode", "data-testid": "link-get-new-code", onClick: handleResendOtpClicked }, localizedContent('getANewCode')))),
                React.createElement(CodeInput, { id: "codeInput", "data-testid": "code-input", errorText: otpFieldError && (React.createElement("span", { id: "otpFieldError", "data-testid": "otp-field-error" }, otpFieldError)), name: "otp", onChange: handleChangeOtp, ref: ref, type: "tel", value: otp, autoComplete: "off", numberOnly: true })),
            React.createElement("br", null),
            React.createElement("div", { style: { margin: '10px 0' } },
                React.createElement(Link, { href: "#", className: "secondaryLink", id: "linkTryAnotherWay", "data-testid": "link-try-another-way", onClick: (e) => {
                        e.preventDefault();
                        logger.track('try_another_way_clicked');
                        setShowTryAnotherWay(true);
                    } }, localizedContent('tryAnotherWay'))))));
};
